import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@repo/ui';
import { memo } from 'react';
interface CloseToLiquidationConfirmBoxProps {
  isRiskyPositionsAcknowledged: boolean;
  setIsRiskyPositionsAcknowledged: (value: boolean) => void;
}
const CloseToLiquidationConfirmBox = t0 => {
  const $ = _c(8);
  const {
    isRiskyPositionsAcknowledged,
    setIsRiskyPositionsAcknowledged
  } = t0;
  let t1;
  if ($[0] !== setIsRiskyPositionsAcknowledged) {
    t1 = checked => setIsRiskyPositionsAcknowledged(checked === true);
    $[0] = setIsRiskyPositionsAcknowledged;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isRiskyPositionsAcknowledged || $[3] !== t1) {
    t2 = <Checkbox id="is-position-risky-checkbox" checked={isRiskyPositionsAcknowledged} onCheckedChange={t1} />;
    $[2] = isRiskyPositionsAcknowledged;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <label className="text-2xs text-destructive-foreground" style={{
      cursor: "pointer"
    }} htmlFor="is-position-risky-checkbox">{"You are close to being liquidated. By clicking the box you understand & acknowledge the risk of the position."}</label>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="gap-xs p-xs bg-destructive-foreground/18 flex items-center rounded-[4px]">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default memo(CloseToLiquidationConfirmBox);